import React from 'react';
import {
    Column,
    DataGrid
} from 'devextreme-react/data-grid';

export default function RecogResultStatusDatagrid({ dataSource }) {
    function gubunRender(e) {
        if (e.data.aiGubun == "원본") {
            return(
                <a></a>
            )
        }
        else {
            return(
                <a>
                    {e.data.aiGubun}
                </a>
            )   
        }
    }

    return (
        <DataGrid dataSource={dataSource}
            height="100%"
            columnAutoWidth={true}
            paging={{
                pageSize: 100
            }}
        >
            <Column dataField="sortNo" caption="NO" alignment="center" width={40}/>
            <Column dataField={dataSource} caption="구분" cellRender={gubunRender} alignment="center"/>
            <Column dataField="wSize" caption="가로" alignment="center" />
            <Column dataField="hSize" caption="세로" alignment="center" />
            <Column dataField="qtyea" caption="수량" alignment="center" />
            <Column dataField="remark" caption="비고" alignment="center" width={250}/>
        </DataGrid>
    );
}